import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../components/Header";
import {
    FiArrowRight,
    FiZap,
    FiCpu,
    FiTrendingUp,
    FiBarChart2,
    FiChevronDown,
    FiUpload,
    } from "react-icons/fi";
    import { useState, useEffect, useRef } from "react";
    
    export default function Main() {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(null);
    
    // ✅ Stats animées par vidéo
    const statsData = [
    { score: "9.0 / 10", improvement: "+61%", views: "+42.1%" },
    { score: "7.4 / 10", improvement: "+33%", views: "+19.6%" },
    { score: "8.2 / 10", improvement: "+48%", views: "+31.8%" },
    { score: "6.9 / 10", improvement: "+22%", views: "+14.3%" },
    ];

    const [index, setIndex] = useState(0);

    useEffect(() => {
    const timing = setInterval(() => {
        setIndex((prev) => (prev + 1) % statsData.length);
    }, 3000);
    return () => clearInterval(timing);
    }, []);

    const currentStat = statsData[index];

    return (
    <div className="bg-[#0D1117] text-[#E6EDF3] min-h-screen flex flex-col">

        {/* HEADER */}
        <Header />

        {/* HERO */}
        <section className="flex flex-col lg:flex-row items-center justify-center text-center lg:text-left px-6 pt-40 pb-28 max-w-6xl mx-auto gap-16">

        {/* LEFT */}
        <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex-1"
        >
        <h1 className="text-5xl sm:text-6xl font-extrabold leading-tight mb-6">
            <span className="bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-transparent bg-clip-text">
            Boost your TikTok hooks
            </span>{" "}
            with AI and{" "}
            <span className="bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-transparent bg-clip-text">
            go viral
            </span>{" "}
            ⚡
        </h1>

        <p className="text-lg text-[#8B949E] mb-8 max-w-lg mx-auto lg:mx-0">
            <strong className="text-[#E6EDF3]">BoostMyHook</strong> analyzes the first
            seconds of your videos, gives you a Hook Score, and tells you exactly
            how to improve retention — instantly.
        </p>

        <div className="flex justify-center lg:justify-start">
            <button
            onClick={() => navigate("/login")}
            className="flex items-center justify-center gap-2 bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-white px-6 py-3 rounded-full text-lg font-medium hover:opacity-90 transition-all duration-200 shadow-[0_0_25px_#3B82F6]/40"
            >
            🎬 Test My Hook <FiArrowRight size={20} />
            </button>
        </div>

        {/* Badges */}
        <div className="flex flex-wrap justify-center lg:justify-start gap-6 mt-10 text-[#8B949E] text-sm">
            <div className="flex items-center gap-2">
            <FiZap className="text-[#3B82F6]" /> 1-click AI analysis
            </div>
            <div className="flex items-center gap-2">
            <FiCpu className="text-[#3B82F6]" /> Powered by OpenAI
            </div>
            <div className="flex items-center gap-2">
            <FiTrendingUp className="text-[#3B82F6]" /> For creators
            </div>
        </div>
        </motion.div>


        {/* ✅ RIGHT VISUAL — New Phone Mockup */}
        <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15, duration: 0.5 }}
        className="flex-1 relative flex justify-center"
        >
        <div className="relative w-[320px] sm:w-[360px] h-[640px] bg-[#11161c] rounded-[2.25rem] border border-[#21262D] shadow-[0_10px_60px_rgba(59,130,246,0.25)] overflow-hidden">

            {/* Notch */}
            <div className="absolute top-3 left-1/2 -translate-x-1/2 w-36 h-6 bg-[#0D1117] rounded-b-2xl border border-[#1e232a]" />

            {/* ✅ Video */}
            <video
            src="/hookvideo.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover pt-10 pb-6"
            />
        </div>

        {/* ✅ Animated Stats */}
        <div className="absolute -left-3 -bottom-5 bg-[#0D1117]/90 backdrop-blur-xl border border-[#2a3340]
            rounded-2xl px-4 py-3 shadow-[0_0_20px_rgba(59,130,246,0.5)]
            transition-all duration-300">
            <p className="text-xs text-[#9BA6B3]">Hook Score</p>
            <p className="text-2xl font-bold text-[#3B82F6]">
            {currentStat.score}
            </p>
            <div className="text-emerald-400 text-xs flex items-center gap-1">
            <FiTrendingUp /> {currentStat.improvement} retention
            </div>
        </div>

        <div className="absolute -right-3 top-5 bg-[#0D1117]/90 backdrop-blur-xl border border-[#2a3340]
            rounded-2xl px-4 py-3 shadow-[0_0_20px_rgba(168,85,247,0.5)]
            transition-all duration-300">
            <p className="text-xs text-[#9BA6B3]">Creators Helped</p>
            <p className="text-2xl font-bold text-[#A855F7]">
            18k+
            </p>
        </div>

        <div className="hidden sm:block absolute -left-6 top-16 bg-[#0D1117]/90 backdrop-blur-xl border border-[#2a3340]
            rounded-2xl px-4 py-3 shadow-[0_0_20px_rgba(6,182,212,0.5)]
            transition-all duration-300">
            <p className="text-xs text-[#9BA6B3]">Views gained</p>
            <p className="text-2xl font-bold text-[#06B6D4]">
            {currentStat.views}
            </p>
        </div>
        </motion.div>

        </section>

        {/* ✅ HOW IT WORKS — Final Version */}
        <section className="py-32 px-6 bg-[#0D1117] border-t border-[#21262D] relative">

        <div className="max-w-5xl mx-auto text-center mb-20">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#E6EDF3] mb-4">
            How it works
            </h2>
            <p className="text-[#8B949E] text-lg max-w-2xl mx-auto">
            From upload to optimized hooks — AI enhances what keeps viewers watching.
            </p>
        </div>

        {/* ✅ Steps Container */}
        <div className="relative max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-14 text-center">

            {/* ✅ CONNECTING PATH */}
            <div className="hidden sm:block absolute top-[50%] left-0 right-0 h-[2px] bg-[#2a3340] -z-10" />
            <div className="sm:hidden absolute left-[50%] top-0 bottom-0 w-[2px] bg-[#2a3340] -z-10" />

            {/* ✅ Steps */}
            {[
            {
                icon: <FiUpload size={26} />,
                title: "Upload your video",
                desc: "MP4 or MOV — we analyze only the first seconds, the most important part.",
            },
            {
                icon: <FiCpu size={26} />,
                title: "AI analyzes your hook",
                desc: "Curiosity, clarity, pacing & voice evaluated with precision.",
            },
            {
                icon: <FiBarChart2 size={26} />,
                title: "Get your Hook Score",
                desc: "Video + Text scoring with actionable, AI-powered improvements.",
            },
            ].map((step, i) => (
                <motion.div
        key={i}
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: i * 0.1 }}
        viewport={{ once: true }}
        className="relative bg-[#0D1117] border border-[#21262D]
            rounded-2xl px-8 py-6 flex flex-col items-center text-center
            drop-shadow-[0_0_25px_rgba(59,130,246,0.35)]
            max-w-xs sm:max-w-sm mx-auto"
        >
        {/* STEP */}
        <p className="text-xs text-[#9BA6B3] tracking-wide mb-3">
            STEP {i + 1}
        </p>

        {/* Icon */}
        <div className="text-[#3B82F6] mb-3">
            {step.icon}
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-[#E6EDF3] mb-2">
            {step.title}
        </h3>

        {/* Description */}
        <p className="text-sm text-[#8B949E] leading-relaxed">
            {step.desc}
        </p>
        </motion.div>


            
            ))}

        </div>
        </section>

    {/* WHAT MAKES A VIRAL HOOK — New visual */}
    <section className="py-32 px-6 bg-[#0D1117] border-t border-[#21262D]">
    <div className="max-w-5xl mx-auto text-center mb-20">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#E6EDF3] mb-4">
        What makes a viral hook? 🔥
        </h2>
        <p className="text-lg text-[#8B949E] max-w-2xl mx-auto">
        Viral hooks are powered by the same 3 psychological triggers, every time.
        </p>
    </div>

    <div className="relative max-w-2xl mx-auto">

        {/* Ligne de connexion */}
        <div className="absolute top-0 bottom-0 left-6 sm:left-1/2 w-[2px] bg-[#1c2630] -z-10 sm:translate-x-[-1px]" />

        {[
        {
            icon: <FiZap size={26} className="text-[#3B82F6]" />,
            title: "Curiosity drives attention",
            text:
            "Your hook must create a gap. A question. A tease. Curiosity forces viewers to stay for the answer.",
        },
        {
            icon: <FiBarChart2 size={26} className="text-[#06B6D4]" />,
            title: "Emotion fuels retention",
            text:
            "Shock, excitement, suspense, empathy — emotions are the engine of virality. Boring kills watch time.",
        },
        {
            icon: <FiCpu size={26} className="text-[#8B5CF6]" />,
            title: "Clarity prevents scrolling",
            text:
            "If viewers need to think, they scroll. Your message must be instant and frictionless.",
        },
        ].map((item, i) => (
        <div
            key={i}
            className="relative flex flex-col sm:flex-row gap-6 items-start sm:items-center mb-16"
        >
            {/* Icon */}
            <div className="bg-[#0D1117] border border-[#21262D] rounded-full p-3 shadow-[0_0_20px_rgba(59,130,246,0.25)]">
            {item.icon}
            </div>

            {/* Text block */}
            <div className="sm:ml-4">
            <h3 className="text-xl font-semibold text-[#E6EDF3] mb-2">
                {item.title}
            </h3>
            <p className="text-sm text-[#8B949E] leading-relaxed">
                {item.text}
            </p>
            </div>
        </div>
        ))}
    </div>
    </section>


        {/* CTA */}
        <section className="py-24 bg-[#0D1117] text-center px-6 border-t border-[#21262D]">
        <h2 className="text-4xl font-bold mb-4">Ready to test your next viral hook?</h2>
        <p className="text-lg mb-8 text-[#8B949E] max-w-xl mx-auto">
            Join creators boosting their retention with AI scoring.
        </p>
        <button
            onClick={() => navigate("/login")}
            className="bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] text-white font-semibold px-8 py-3 rounded-full text-lg hover:opacity-90 transition shadow-[0_0_25px_#3B82F6]/40"
        >
            🚀 Try BoostMyHook Free
        </button>
        </section>

        {/* ✅ FAQ */}
        <section className="py-32 bg-[#0D1117] px-6 border-t border-[#21262D]">
        <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#E6EDF3] mb-4">
            Frequently Asked Questions
            </h2>
            <p className="text-[#8B949E]">
            Clear answers for creators serious about growing.
            </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
            {[
            {
                q: "What is BoostMyHook?",
                a: "BoostMyHook is an AI performance tool built for TikTok, Shorts and Reels creators. We analyze the first seconds of your video and give you a Hook Score + actionable improvements to boost your retention."
            },
            {
                q: "How does BoostMyHook analyze my hook?",
                a: "We break down your video into 4 key factors: curiosity, clarity, pacing and emotional impact. Audio, text and visuals are all evaluated by AI to determine how likely viewers are to keep watching."
            },
            {
                q: "Do I need to edit my video before uploading?",
                a: "No editing required. Just upload your video — BoostMyHook automatically focuses on the opening seconds and handles everything else for you."
            },
            {
                q: "Is my content stored?",
                a: "No. Your video is processed securely, never used for training, and permanently deleted after the analysis unless you explicitly save it."
            },
            {
                q: "Does it work in any language?",
                a: "Yes! We support multiple languages including English, French and Spanish. Speech is automatically detected and transcribed."
            },
            ].map((faq, i) => (
            <div
                key={i}
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="bg-[#0D1117] border border-[#21262D] rounded-xl p-6 
                cursor-pointer transition-all duration-200
                hover:border-[#3B82F6]/60 hover:shadow-[0_0_25px_rgba(59,130,246,0.25)]"
            >
                <div className="flex justify-between items-center gap-4">
                <h3 className="text-lg font-semibold text-[#E6EDF3]">
                    {faq.q}
                </h3>
                <FiChevronDown
                    className={`transition-all duration-300 text-[#8B949E] ${
                    openIndex === i ? "rotate-180 text-[#3B82F6]" : ""
                    }`}
                />
                </div>

                {openIndex === i && (
                <p className="text-[#8B949E] text-sm mt-3 leading-relaxed">
                    {faq.a}
                </p>
                )}
            </div>
            ))}
        </div>
        </section>


        {/* FOOTER */}
        <footer className="py-10 px-6 border-t border-[#21262D] bg-[#0D1117]">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
            
            {/* Logo + Copyright */}
            <p className="text-[#8B949E] text-sm">
            © {new Date().getFullYear()} <span className="text-[#E6EDF3] font-medium">BoostMyHook</span> — All rights reserved.
            </p>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm">
            <a
                href="/legal/mentions"
                className="text-[#8B949E] hover:text-[#3B82F6] transition-colors"
            >
                Legal Metions
            </a>
            <a
                href="/legal/privacy"
                className="text-[#8B949E] hover:text-[#3B82F6] transition-colors"
            >
                Privacy Policy
            </a>
            </div>
        </div>
        </footer>

    </div>
    );
}
